import React, { useState, useRef, useEffect } from "react";
import "./DropdownButton.scss";

const DropdownButton = ({ label = "Nuevo", icon = "add", items = [], className = "", disabled = false }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const handleOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handleOutside);
        return () => document.removeEventListener("mousedown", handleOutside);
    }, []);

    const handleItemClick = (item) => {
        setOpen(false);
        item.onClick?.();
    };

    return (
        <div className={`dropdown-button ${className}`} ref={ref}>
            <button
                className="dropdown-button__trigger"
                onClick={() => !disabled && setOpen((p) => !p)}
                disabled={disabled}
            >
                {icon && <span className="icon" data-icon={icon} />}
                <span className="dropdown-button__label">{label}</span>
                <span className={`icon dropdown-button__chevron ${open ? "open" : ""}`} data-icon="expand_more" />
            </button>

            {open && (
                <ul className="dropdown-button__menu">
                    {items.map((item, i) => (
                        <li key={i} className="dropdown-button__item" onClick={() => handleItemClick(item)}>
                            {item.icono && <span className="icon dropdown-button__item-icon" data-icon={item.icono} />}
                            <span className="dropdown-button__item-label">{item.title}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default DropdownButton;
